var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { CampaignService } from './campaign.service';
var CampaignContentsComponent = /** @class */ (function (_super) {
    __extends(CampaignContentsComponent, _super);
    function CampaignContentsComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.defMode = '';
        _this.readonly = false;
        _this.campaignId = 0;
        _this.campaignList = [];
        _this.campaignListId = 0;
        _this.mediaList = [];
        _this.medias = [];
        _this.langList = [];
        _this.langs = [];
        _this.segments = [];
        _this.contents = {};
        _this.disp = {};
        _this.langErr = false;
        return _this;
    }
    CampaignContentsComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.modal = this.remodalElement.nativeElement;
    };
    CampaignContentsComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        if (this.component.params && this.component.params.mode) {
            this.defMode = this.component.params.mode;
        }
        if (this.component.params && this.component.params.readonly === true) {
            this.readonly = true;
        }
    };
    CampaignContentsComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    CampaignContentsComponent.prototype.onSubscribe = function (data) {
        this.campaignId = 0;
        if (data.campaign_id) {
            this.campaignId = data.campaign_id;
        }
        this.setMedias();
        this.segments = [];
        this.contents = {};
        var segments = jsonpath.value(data, '$..segmentM');
        if (segments) {
            this.service.sortPriority(segments);
            for (var _i = 0, segments_1 = segments; _i < segments_1.length; _i++) {
                var segment = segments_1[_i];
                this.segments.push({
                    segment_id: segment.segment_id,
                    segment_title: segment.segment_title,
                    contents: [
                        { type: MediaType.email, data: segment.campaignContentsEmail },
                        { type: MediaType.webmessage, data: segment.campaignContentsWebmessage },
                        { type: MediaType.push, data: segment.campaignContentsPush },
                        { type: MediaType.sms, data: segment.campaignContentsSms }
                    ]
                });
            }
        }
        if (this.segments.length > 0) {
            this.getList();
        }
    };
    CampaignContentsComponent.prototype.onModeSubscribe = function (mode) {
        if (this.defMode !== mode) {
            this.action.deleteCompRec(this.componentName);
        }
    };
    CampaignContentsComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    CampaignContentsComponent.prototype.trackByMedia = function (index, media) {
        return media.type;
    };
    CampaignContentsComponent.prototype.trackBySegment = function (index, segment) {
        return segment.segment_id;
    };
    CampaignContentsComponent.prototype.trackByLang = function (index, lang) {
        return lang.lang;
    };
    CampaignContentsComponent.prototype.getList = function () {
        var _this = this;
        this.langList = [];
        this.service.getLanguageList().subscribe(function (rec) {
            if (rec instanceof Array) {
                for (var _i = 0, rec_1 = rec; _i < rec_1.length; _i++) {
                    var lang = rec_1[_i];
                    _this.langList.push(Object.assign(new Language(), lang));
                }
            }
            _this.setInitData();
            _this.setContents();
        });
        this.campaignList = [];
        this.campaignListId = 0;
        if (!this.readonly) {
            this.service.getCampaignList().subscribe(function (rec) {
                if (rec instanceof Array) {
                    _this.campaignList = rec;
                }
            });
        }
    };
    // 過去の施策をコピー
    CampaignContentsComponent.prototype.copyCampaign = function (id) {
        var _this = this;
        if (id === 0) {
            return;
        }
        this.service.getCampaign(id).subscribe(function (rec) {
            if (typeof rec !== 'undefined') {
                var segments = jsonpath.value(rec, '$..segmentM');
                if (segments) {
                    _this.service.sortPriority(segments);
                    for (var i = 0; i < _this.segments.length; i++) {
                        var segment = segments[i];
                        _this.segments[i].contents = [
                            { type: MediaType.email, data: segment ? segment.campaignContentsEmail : [] },
                            { type: MediaType.webmessage, data: segment ? segment.campaignContentsWebmessage : [] },
                            { type: MediaType.push, data: segment ? segment.campaignContentsPush : [] },
                            { type: MediaType.sms, data: segment ? segment.campaignContentsSms : [] }
                        ];
                    }
                }
                for (var key in _this.contents) {
                    _this.contents[key].delete = true;
                    _this.contents[key].data = new ContentData();
                }
                _this.setInitData();
                _this.setContents('copy');
            }
        });
    };
    CampaignContentsComponent.prototype.setMedias = function () {
        this.mediaList = [];
        this.mediaList.push(Object.assign(new Media(), {
            type: MediaType.email,
            name: this.msgSnapshot['CampaignContentsComponent.media.email'],
            item: { title: true, summary: false, contents: true, contents_html: true, textarea_rows: 15 }
        }));
        this.mediaList.push(Object.assign(new Media(), {
            type: MediaType.webmessage,
            name: this.msgSnapshot['CampaignContentsComponent.media.webmessage'],
            item: { title: true, summary: true, contents: false, contents_html: false, textarea_rows: 6 }
        }));
        this.mediaList.push(Object.assign(new Media(), {
            type: MediaType.push,
            name: this.msgSnapshot['CampaignContentsComponent.media.push'],
            item: { title: true, summary: false, contents: false, contents_html: false }
        }));
        this.mediaList.push(Object.assign(new Media(), {
            type: MediaType.sms,
            name: this.msgSnapshot['CampaignContentsComponent.media.sms'],
            item: { title: false, summary: false, contents: true, contents_html: false, textarea_rows: 6 }
        }));
    };
    CampaignContentsComponent.prototype.setInitData = function () {
        this.medias = [];
        this.langs = [];
        for (var _i = 0, _a = this.segments; _i < _a.length; _i++) {
            var segment = _a[_i];
            for (var _b = 0, _c = segment.contents; _b < _c.length; _b++) {
                var content = _c[_b];
                if (content.data.length > 0) {
                    this.medias.push(content.type);
                }
                for (var _d = 0, _e = content.data; _d < _e.length; _d++) {
                    var data = _e[_d];
                    this.langs.push(data.lang_code);
                }
            }
        }
        for (var _f = 0, _g = this.langList; _f < _g.length; _f++) {
            var lang = _g[_f];
            lang.checked = this.langs.indexOf(lang.lang) >= 0 ? true : false;
        }
        // 言語が未選択の場合は1つ目の言語をセットする
        if (this.langs.length === 0) {
            this.langList[0].checked = true;
            this.langs.push(this.langList[0].lang);
        }
        this.disp = {};
        for (var _h = 0, _j = this.mediaList; _h < _j.length; _h++) {
            var media = _j[_h];
            media.checked = this.medias.indexOf(media.type) >= 0 ? true : false;
            this.disp[media.type] = new Disp();
            if (media.type === MediaType.sms) {
                this.disp[media.type].content = 'text';
            }
            for (var _k = 0, _l = this.langList; _k < _l.length; _k++) {
                var lang = _l[_k];
                if (lang.checked) {
                    this.disp[media.type].lang = lang.lang;
                    break;
                }
            }
            if (this.segments.length > 0) {
                this.disp[media.type].segment = this.segments[0].segment_id;
            }
        }
    };
    CampaignContentsComponent.prototype.setContents = function (mode) {
        for (var _i = 0, _a = this.segments; _i < _a.length; _i++) {
            var segment = _a[_i];
            for (var _b = 0, _c = segment.contents; _b < _c.length; _b++) {
                var content = _c[_b];
                for (var _d = 0, _e = content.data; _d < _e.length; _d++) {
                    var data = _e[_d];
                    var contents_id = { contents_id: data.contents_id };
                    if (mode && mode === 'copy') {
                        contents_id = {};
                    }
                    this.contents[content.type + '-' + data.lang_code + '-' + segment.segment_id] = Object.assign(new Content(), contents_id, {
                        media_type: content.type,
                        lang_code: data.lang_code,
                        segment_id: segment.segment_id,
                        data: {
                            title: data.title || '',
                            summary: data.summary || '',
                            contents: data.contents_text || '',
                            contents_html: data.contents_html || ''
                        }
                    });
                }
            }
        }
        this.changeContents();
    };
    CampaignContentsComponent.prototype.openRemodal = function () {
        this.langErr = false;
        this.remodal = $(this.modal).remodal({ hashTracking: false, closeOnEscape: false, closeOnOutsideClick: false });
        this.remodal.open();
    };
    CampaignContentsComponent.prototype.cancelRemodal = function () {
        for (var _i = 0, _a = this.langList; _i < _a.length; _i++) {
            var lang = _a[_i];
            if ((lang.checked && this.langs.indexOf(lang.lang) == -1) || (!lang.checked && this.langs.indexOf(lang.lang) >= 0)) {
                lang.checked = !lang.checked;
            }
        }
    };
    CampaignContentsComponent.prototype.closeRemodal = function () {
        this.langErr = true;
        for (var _i = 0, _a = this.langList; _i < _a.length; _i++) {
            var lang = _a[_i];
            if (lang.checked) {
                for (var _b = 0, _c = this.mediaList; _b < _c.length; _b++) {
                    var media = _c[_b];
                    this.disp[media.type].lang = lang.lang;
                }
                this.langErr = false;
                break;
            }
        }
        if (!this.langErr) {
            this.changeContents();
            this.remodal.close();
        }
    };
    CampaignContentsComponent.prototype.changeContents = function () {
        this.medias = [];
        this.langs = [];
        for (var _i = 0, _a = this.mediaList; _i < _a.length; _i++) {
            var media = _a[_i];
            for (var _b = 0, _c = this.langList; _b < _c.length; _b++) {
                var lang = _c[_b];
                for (var _d = 0, _e = this.segments; _d < _e.length; _d++) {
                    var segment = _e[_d];
                    var deleteFlg = true;
                    if (media.checked && lang.checked) {
                        deleteFlg = false;
                    }
                    var content = this.contents[media.type + '-' + lang.lang + '-' + segment.segment_id];
                    if (content) {
                        content.delete = deleteFlg;
                    }
                    else {
                        if (lang.checked) {
                            this.contents[media.type + '-' + lang.lang + '-' + segment.segment_id] = Object.assign(new Content(), {
                                media_type: media.type,
                                lang_code: lang.lang,
                                segment_id: segment.segment_id,
                                delete: deleteFlg
                            });
                        }
                    }
                }
                if (lang.checked && this.langs.indexOf(lang.lang) == -1) {
                    this.langs.push(lang.lang);
                }
            }
            if (media.checked) {
                this.medias.push(media.type);
            }
        }
        this.setContentsData();
    };
    CampaignContentsComponent.prototype.changeDisp = function (type, key, val) {
        this.disp[type][key] = val;
    };
    CampaignContentsComponent.prototype.setContentsData = function () {
        var contents = [];
        for (var _i = 0, _a = this.segments; _i < _a.length; _i++) {
            var segment = _a[_i];
            var content = [];
            var conts = jsonpath.query(this.contents, '$..[?(@.segment_id==' + segment.segment_id + ')]');
            for (var _b = 0, conts_1 = conts; _b < conts_1.length; _b++) {
                var cont = conts_1[_b];
                if (!cont.contents_id && cont.delete) {
                    continue;
                }
                var c = Object.assign({}, cont, cont.data);
                delete c.contents_id;
                delete c.segment_id;
                delete c.data;
                var item = jsonpath.value(this.mediaList, '$..[?(@.type=="' + c.media_type + '")].item');
                for (var key in item) {
                    if (!item[key]) {
                        delete c[key];
                    }
                }
                content.push(c);
            }
            contents.push({ segment_id: segment.segment_id, contents_data: content });
        }
        this.action.setCompRec(this.componentName, { campaign_id: this.campaignId, items: contents });
    };
    CampaignContentsComponent.prototype.setContentsTag = function (tag, name, type) {
        var textarea = document.getElementById(name + '-' + type);
        var sentence = textarea.value;
        var len = sentence.length;
        var pos = textarea.selectionStart;
        var beforeString = textarea.value.substring(0, pos);
        var afterString = textarea.value.substring(pos, len);
        if (type === 'html') {
            this.contents[name].data.contents_html = beforeString + tag + afterString;
        }
        else {
            this.contents[name].data.contents = beforeString + tag + afterString;
        }
        textarea.value = beforeString + tag + afterString;
        pos = (beforeString + tag).length;
        textarea.focus();
        textarea.setSelectionRange(pos, pos);
        this.setContentsData();
    };
    CampaignContentsComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if ($(this.modal).parent().hasClass('remodal-wrapper')) {
            this.remodal.destroy();
        }
    };
    CampaignContentsComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'campaign-contents',
                    template: "<div *ngIf=\"defMode === mode\" id=\"{{ componentName }}\">\n  <div *ngIf=\"!readonly\" class=\"row -m-3\">\n    <div class=\"col-sm-12\">\n      <dl class=\"form\">\n        <dt class=\"form_dt\"></dt>\n        <dd class=\"form_dd\">\n          <ul>\n            <li class=\"form_li\">\n              <select [(ngModel)]=\"campaignListId\" name=\"campaignList\" class=\"formSelect\">\n                <option [ngValue]=\"0\" [selected]=\"campaignListId === 0\">{{ (msg | async)['CampaignContentsComponent.label.selectCampaign'] }}</option>\n                <option *ngFor=\"let option of campaignList; trackBy: trackByOption\" [ngValue]=\"option.code\">{{ option.display }}</option>\n              </select>\n            </li>\n            <li class=\"form_li\">\n              <a href=\"javascript:void(0);\" (click)=\"copyCampaign(campaignListId)\">{{ (msg | async)['CampaignContentsComponent.label.copy'] }}</a>\n            </li>\n          </ul>\n        </dd>\n      </dl>\n    </div>\n  </div>\n  <horizontal-rule *ngIf=\"!readonly\"></horizontal-rule>\n  <div *ngIf=\"!readonly\" class=\"row -mx-3 -my-2\">\n    <div class=\"col-sm-12\">\n      <p><a href=\"javascript:void(0);\" (click)=\"openRemodal()\">{{ (msg | async)['Component.label.selectLanguage'] }}</a></p>\n    </div>\n  </div>\n  <horizontal-rule *ngIf=\"!readonly\"></horizontal-rule>\n  <ng-template [ngIf]=\"langs.length > 0\">\n    <ng-template ngFor let-media [ngForOf]=\"mediaList\" [ngForTrackBy]=\"trackByMedia\">\n      <div *ngIf=\"!readonly || (readonly && media.checked)\" class=\"row -mx-3 -my-2\">\n        <div class=\"col-sm-12\">\n          <ng-template [ngIf]=\"!readonly\" [ngIfElse]=\"elseBlock\">\n            <input class=\"formInputCheckbox\" type=\"checkbox\" id=\"{{ media.type }}\" name=\"{{ media.type }}\" [(ngModel)]=\"media.checked\" (change)=\"changeContents()\">\n            <label class=\"formInputCheckboxLabel\" for=\"{{ media.type }}\">{{ media.name }}</label>\n          </ng-template>\n          <ng-template #elseBlock>\n            <p class=\"-mb-1\">{{ media.name }}</p>\n          </ng-template>\n          <div class=\"formToggle\">\n            <ul class=\"tabsMenu\">\n              <ng-template ngFor let-lang [ngForOf]=\"langList\" [ngForTrackBy]=\"trackByLang\">\n                <li *ngIf=\"langs.indexOf(lang.lang) >= 0\" [class.tabsMenu_current]=\"disp[media.type].lang === lang.lang\">\n                  <a href=\"javascript:void(0);\" (click)=\"changeDisp(media.type, 'lang', lang.lang)\">{{ lang.label }}</a>\n                </li>\n              </ng-template>\n            </ul>\n            <ul class=\"tabsMenu2 -mb-05\">\n              <li *ngFor=\"let segment of segments; trackBy: trackBySegment\" [class.tabsMenu2_current]=\"disp[media.type].segment === segment.segment_id\">\n                <a href=\"javascript:void(0);\" (click)=\"changeDisp(media.type, 'segment', segment.segment_id)\">{{ segment.segment_title }}</a>\n              </li>\n            </ul>\n            <div *ngIf=\"contents[media.type+'-'+disp[media.type].lang+'-'+disp[media.type].segment]\" class=\"forms forms-campaign stageFlowPane_border\">\n              <dl *ngIf=\"media.item.title\" class=\"form\">\n                <dt class=\"form_dt\"><label class=\"formLabelText\">{{ (msg | async)['CampaignContentsComponent.label.title'] }}</label></dt>\n                <dd class=\"form_dd\">\n                  <ul *ngIf=\"!readonly\">\n                    <li class=\"form_li form_li-w100per\">\n                      <input class=\"formInputText\" type=\"text\"\n                             id=\"{{ media.type+'-'+disp[media.type].lang+'-'+disp[media.type].segment+'-title' }}\"\n                             name=\"{{ media.type+'-'+disp[media.type].lang+'-'+disp[media.type].segment+'-title' }}\"\n                             [(ngModel)]=\"contents[media.type+'-'+disp[media.type].lang+'-'+disp[media.type].segment].data.title\" (change)=\"setContentsData()\">\n                    </li>\n                  </ul>\n                  <ul *ngIf=\"readonly\">\n                    <li class=\"form_li form_li-w100per\">\n                      <column-formreadonly [col]=\"{controlType: 'text'}\" [val]=\"contents[media.type+'-'+disp[media.type].lang+'-'+disp[media.type].segment].data.title\" [msg]=\"(msg | async)\"></column-formreadonly>\n                    </li>\n                  </ul>\n                </dd>\n              </dl>\n              <dl *ngIf=\"media.item.summary\" class=\"form\" [class.-mt-2]=\"media.item.title\">\n                <dt class=\"form_dt\"><label class=\"formLabelText\">{{ (msg | async)['CampaignContentsComponent.label.summary'] }}</label></dt>\n                <dd class=\"form_dd\">\n                  <ul *ngIf=\"!readonly\">\n                    <li class=\"form_li form_li-w100per\">\n                                            <textarea class=\"formTextArea\" rows=\"{{ media.item.textarea_rows }}\"\n                                                      id=\"{{ media.type+'-'+disp[media.type].lang+'-'+disp[media.type].segment+'-summary' }}\"\n                                                      name=\"{{ media.type+'-'+disp[media.type].lang+'-'+disp[media.type].segment+'-summary' }}\"\n                                                      [(ngModel)]=\"contents[media.type+'-'+disp[media.type].lang+'-'+disp[media.type].segment].data.summary\" (change)=\"setContentsData()\"></textarea>\n                    </li>\n                  </ul>\n                  <ul *ngIf=\"readonly\">\n                    <li class=\"form_li form_li-w100per\">\n                      <column-formreadonly [col]=\"{controlType: 'textarea'}\" [val]=\"contents[media.type+'-'+disp[media.type].lang+'-'+disp[media.type].segment].data.summary\" [msg]=\"(msg | async)\"></column-formreadonly>\n                    </li>\n                  </ul>\n                </dd>\n              </dl>\n              <dl *ngIf=\"media.item.contents || media.item.contents_html\" class=\"form\" [class.-mt-2]=\"media.item.title\">\n                <dt class=\"form_dt\"><label class=\"formLabelText\">{{ (msg | async)['CampaignContentsComponent.label.contents'] }}</label></dt>\n                <dd class=\"form_dd\">\n                  <ul class=\"tabsMenu2 -mb-05\">\n                    <li *ngIf=\"media.item.contents_html\" [class.tabsMenu2_current]=\"disp[media.type].content === 'html'\">\n                      <a href=\"javascript:void(0);\" (click)=\"changeDisp(media.type, 'content', 'html')\">{{ (msg | async)['Component.label.html'] }}</a>\n                    </li>\n                    <li *ngIf=\"media.item.contents\" [class.tabsMenu2_current]=\"disp[media.type].content === 'text'\">\n                      <ng-template [ngIf]=\"media.item.contents_html\">\n                        <a href=\"javascript:void(0);\" (click)=\"changeDisp(media.type, 'content', 'text')\">{{ (msg | async)['Component.label.text'] }}</a>\n                      </ng-template>\n                      <ng-template [ngIf]=\"!media.item.contents_html\">{{ (msg | async)['Component.label.text'] }}</ng-template>\n                    </li>\n                  </ul>\n                  <ul *ngIf=\"!readonly\">\n                    <li class=\"form_li form_li-w100per\">\n                                            <textarea *ngIf=\"disp[media.type].content === 'html'\" class=\"formTextArea\" rows=\"{{ media.item.textarea_rows }}\"\n                                                      id=\"{{ media.type+'-'+disp[media.type].lang+'-'+disp[media.type].segment+'-html' }}\"\n                                                      name=\"{{ media.type+'-'+disp[media.type].lang+'-'+disp[media.type].segment+'-html' }}\"\n                                                      [(ngModel)]=\"contents[media.type+'-'+disp[media.type].lang+'-'+disp[media.type].segment].data.contents_html\" (change)=\"setContentsData()\"></textarea>\n                      <textarea *ngIf=\"disp[media.type].content === 'text'\" class=\"formTextArea\" rows=\"{{ media.item.textarea_rows }}\"\n                                id=\"{{ media.type+'-'+disp[media.type].lang+'-'+disp[media.type].segment+'-text' }}\"\n                                name=\"{{ media.type+'-'+disp[media.type].lang+'-'+disp[media.type].segment+'-text' }}\"\n                                [(ngModel)]=\"contents[media.type+'-'+disp[media.type].lang+'-'+disp[media.type].segment].data.contents\" (change)=\"setContentsData()\"></textarea>\n                    </li>\n                  </ul>\n                  <ul *ngIf=\"readonly\">\n                    <li class=\"form_li form_li-w100per\">\n                      <column-formreadonly *ngIf=\"disp[media.type].content === 'html'\" [col]=\"{controlType: 'textarea'}\" [val]=\"contents[media.type+'-'+disp[media.type].lang+'-'+disp[media.type].segment].data.contents_html\" [msg]=\"(msg | async)\"></column-formreadonly>\n                      <column-formreadonly *ngIf=\"disp[media.type].content === 'text'\" [col]=\"{controlType: 'textarea'}\" [val]=\"contents[media.type+'-'+disp[media.type].lang+'-'+disp[media.type].segment].data.contents\" [msg]=\"(msg | async)\"></column-formreadonly>\n                    </li>\n                  </ul>\n                  <ul *ngIf=\"!readonly\" class=\"-listStyle-separator -mt-1\">\n                    <li><a href=\"javascript:void(0);\" (click)=\"setContentsTag('\\{\\{sei\\}\\} \\{\\{mei\\}\\}', media.type+'-'+disp[media.type].lang+'-'+disp[media.type].segment, disp[media.type].content)\">{{ (msg | async)['CampaignContentsComponent.label.insertTag'] }}</a></li>\n                    <li><a href=\"javascript:void(0);\" (click)=\"setContentsTag('\\{\\{campaign_url\\}\\}', media.type+'-'+disp[media.type].lang+'-'+disp[media.type].segment, disp[media.type].content)\">{{ (msg | async)['CampaignContentsComponent.label.campaignTag'] }}</a></li>\n                    <li><a href=\"javascript:void(0);\">{{ (msg | async)['CampaignContentsComponent.label.setCommonText'] }}</a></li>\n                    <li><a href=\"javascript:void(0);\">{{ (msg | async)['CampaignContentsComponent.label.deleteCommonText'] }}</a></li>\n                  </ul>\n                </dd>\n              </dl>\n            </div>\n          </div>\n        </div>\n      </div>\n    </ng-template>\n  </ng-template>\n</div>\n<!-- remodal -->\n<div class=\"remodal\" data-remodal-id=\"stageFlow_lang\" #remodal>\n  <p>{{ (msg | async)['Component.modal.selectLanguage'] }}</p>\n  <ul class=\"remodal_regionList\">\n    <li *ngFor=\"let lang of langList; trackBy: trackByLang\">\n      <input type=\"checkbox\" id=\"contents-{{ lang.lang }}\" name=\"lang\" [checked]=\"lang.checked\" (change)=\"lang.checked=!lang.checked\">\n      <label for=\"contents-{{ lang.lang }}\" class=\"remodal_regionList_btn\">\n        <img class=\"hNav_user_lang_flag\" src=\"{{ lang.img }}\" alt=\"\">{{ lang.label }}\n      </label>\n    </li>\n  </ul>\n  <p *ngIf=\"langErr\" class=\"-comment\">{{ (msg | async)['Component.modal.unselected'] }}</p>\n  <div class=\"remodal_btns\">\n    <ul class=\"remodal_btns_group\">\n      <li>\n        <button data-remodal-action=\"cancel\" type=\"reset\" class=\"remodal_btns_group-cancel\" (click)=\"cancelRemodal()\">{{ (msg | async)['Component.modal.button.cancel'] }}</button>\n      </li>\n      <li>\n        <button type=\"submit\" class=\"remodal_btns_group-ok\" (click)=\"closeRemodal()\">{{ (msg | async)['Component.modal.button.ok'] }}</button>\n      </li>\n    </ul>\n  </div>\n</div>\n<!-- /remodal -->\n"
                }] }
    ];
    /** @nocollapse */
    CampaignContentsComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: CampaignService }
    ]; };
    CampaignContentsComponent.propDecorators = {
        remodalElement: [{ type: ViewChild, args: ['remodal',] }]
    };
    return CampaignContentsComponent;
}(ContentBaseComponent));
export { CampaignContentsComponent };
var Segment = /** @class */ (function () {
    function Segment() {
        this.contents = [];
    }
    return Segment;
}());
var Media = /** @class */ (function () {
    function Media() {
        this.checked = false;
    }
    return Media;
}());
var Item = /** @class */ (function () {
    function Item() {
    }
    return Item;
}());
var Content = /** @class */ (function () {
    function Content() {
        this.delete = false;
        this.data = new ContentData();
    }
    return Content;
}());
var ContentData = /** @class */ (function () {
    function ContentData() {
        this.title = ''; // email, push, webmessage
        this.summary = ''; // webmessage
        this.contents = ''; // email, sms
        this.contents_html = ''; // email
    }
    return ContentData;
}());
var Disp = /** @class */ (function () {
    function Disp() {
        this.content = 'html'; // html, text
    }
    return Disp;
}());
var Language = /** @class */ (function () {
    function Language() {
        this.checked = false;
    }
    return Language;
}());
export var MediaType;
(function (MediaType) {
    MediaType.email = 'email';
    MediaType.webmessage = 'webmessage';
    MediaType.push = 'push';
    MediaType.sms = 'sms';
})(MediaType || (MediaType = {}));
//# sourceMappingURL=campaign-contents.component.js.map